// src/components/ui/AlertBadge.jsx — v8.4 FINAL
export default function AlertBadge({ status = "info" }) {
  const colors = {
    critical: "var(--danger)",
    high:     "var(--danger)",
    warning:  "var(--warning)",
    medium:   "var(--warning)",
    info:     "var(--accent-primary)",
    low:      "var(--text-muted)",
  };
  const color = colors[status?.toLowerCase()] ?? colors.info;
  return (
    <span style={{
      display:      "inline-block",
      width:        8,
      height:       8,
      borderRadius: "50%",
      background:   color,
      boxShadow:    `0 0 6px ${color}`,
      flexShrink:   0,
    }} />
  );
}
